import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-coupon-modal',
  templateUrl: './coupon-modal.component.html',
  styleUrls: ['./coupon-modal.component.css']
})
export class CouponModalComponent implements OnInit {
  data: any = [];
  sponsor = "";
  redeemable = "Gujco Mart";
  constructor(
    public dialogRef: MatDialogRef<CouponModalComponent>,
    @Inject(MAT_DIALOG_DATA) private confModel: any
  ) {
    this.data = confModel;
    console.log(this.data);

  }

  ngOnInit() {

  }
    onDownloadPdf() {
  const printWindow =  window.open('', '', '_blank');
  printWindow.document.open();
  printWindow.document.write(`<html><head><title>Customer Reward Point Ledger</title> <link rel="stylesheet" href="/assets/css/coupon.css"> </head><body onload="window.print(); window.close();"><div class="coupan-container" >${document.querySelector('#coupons').innerHTML}</div></body></html> `);
  printWindow.document.close();
}

}
